<template>
  <div class="px-6 py-4 border-l border-white/10 shrink-0 flex flex-col">
    <div data-cy="keypad-display" class="text-center text-2xl font-semibold">
      {{ pressedKeys }}
    </div>
    <div class="grid grid-cols-3 gap-4 justify-between mt-auto">
      <button
        v-for="item in KEY_PAD_ITEMS"
        :key="item"
        data-cy="keypad-button"
        class="w-10 h-10 rounded-full bg-white/10 hover:bg-label flex items-center justify-center"
        @click="pressKey(item)"
      >
        <span class="text-base font-semibold">
          {{ item }}
        </span>
      </button>
    </div>
  </div>
</template>
<script setup lang="ts">
import { onMounted, onUnmounted, ref } from "vue";

const emit = defineEmits<{ "keypad:press": [string] }>();

const KEY_PAD_ITEMS = new Set([
  "1",
  "2",
  "3",
  "4",
  "5",
  "6",
  "7",
  "8",
  "9",
  "*",
  "0",
  "#",
]);

const pressedKeys = ref("");

const pressKey = (key: string) => {
  pressedKeys.value += key;
  emit("keypad:press", key);
};

const handleKeydown = (event: KeyboardEvent) => {
  if (KEY_PAD_ITEMS.has(event.key)) {
    pressKey(event.key);
  }
};

onMounted(() => {
  window.addEventListener("keydown", handleKeydown);
  window.documentPictureInPicture?.window?.addEventListener(
    "keydown",
    handleKeydown
  );
});

onUnmounted(() => {
  window.removeEventListener("keydown", handleKeydown);
  window.documentPictureInPicture?.window?.removeEventListener(
    "keydown",
    handleKeydown
  );
});
</script>
